export const getSubscribeButtonAnalytics = () => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction: "my account:account settings:subscribe",
    eventName: "my account:account settings:subscribe",
    eventStatus: "n/a",
    eventMsg: "n/a",
    eventType: "navigation",
    internalLinkName: "subscribe",
    internalLinkPosition: "my account",
    internalLinkType: "my account:communication preferences",
    internalLinkURL: "n/a",
    internalLinkZoneName: "my account:account settings",
  })
}
